<template>
  <div>
    <fieldset>
      <legend class="text-blue ts-font-robot">
        {{ $t('promotion.condition') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              {{ $t('promotion.condition') }}
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="overflow-auto ts-max-h-40">
        <div class="table-ui-detail">
          <table>
            <thead>
              <tr>
                <th width="2%" class="ts-text-center">{{ $t('no') }}</th>
                <th width="9%">{{ $t('promotion.productGroup') }}</th>
                <th width="9%">{{ $t('promotion.barcode') }}</th>
                <th width="15%">{{ $t('promotion.product') }}</th>
                <th width="9%">{{ $t('promotion.sign') }}</th>
                <th width="9%">{{ $t('promotion.amountFrom') }}</th>
                <th width="9%">{{ $t('promotion.amountTo') }}</th>
                <th width="9%">{{ $t('promotion.discountType') }}</th>
                <th width="9%">{{ $t('promotion.discountRate') }}</th>
                <th width="9%">{{ $t('promotion.incentiveType') }}</th>
                <th width="9%">{{ $t('promotion.incentiveRate') }}</th>
                <th width="3%" class="ts-text-center">
                  <a href="#" @click.prevent="addItem">
                    <i class="fa fa-plus"></i>
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="model.condition.length == 0">
                <td colspan="12" class="ts-text-center ts-p-3 ts-space-x-1">
                  <i class="fa fa-folder-open ts-text-gray-200"></i>
                  <label class="ts-text-gray-400">
                    {{ $t('noData') }}
                  </label>
                </td>
              </tr>
              <tr v-for="(item, index) in model.condition" :key="index">
                <td class="ts-whitespace-no-wrap ts-text-center">
                  {{ index + 1 }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  {{ getProduct(item.product_id) ? getProduct(item.product_id).pro_group_name_en : 'N/A' }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  {{ getProduct(item.product_id) ? getProduct(item.product_id).barcode : 'N/A' }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  {{ getProduct(item.product_id) ? getProduct(item.product_id).product_name_en : 'N/A' }}
                </td>
                <td>
                  <a-select v-model="item.operator_sign" class="ts-w-full" style="min-width: 50px"
                    @change="operatorChange(item)">
                    <a-select-option value="=">Equal</a-select-option>
                    <a-select-option value="between">Between</a-select-option>
                    <a-select-option value=">=">Greater or equal</a-select-option>
                  </a-select>
                  <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.operator_sign')">
                    {{ errors.first('condition.' + index + '.operator_sign') }}
                  </div>
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <ts-currency-converter-input :input_amount.sync="item.input_amount_from"
                    :amount.sync="item.amount_from" :input_currency_id.sync="item.input_currency_id"
                    :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                    :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 60px;" />
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <ts-currency-converter-input :input_amount.sync="item.input_amount_to" :amount.sync="item.amount_to"
                    :input_currency_id.sync="item.input_currency_id" :currency_id.sync="item.currency_id"
                    :fx_rate.sync="item.fx_rate" :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 60px;" />
                </td>
                <td>
                  <a-select v-model="item.discount_type" class="ts-w-full" style="min-width: 50px"
                    @change="onChangeItem(item)">
                    <a-select-option value="%">%</a-select-option>
                    <a-select-option :value="getDiscountCurrency(item.input_currency_id)">
                      {{ getDiscountCurrency(item.input_currency_id) }}
                    </a-select-option>
                  </a-select>
                </td>
                <td>
                  <input v-if="item.discount_type == '%'" ref="discountRate" type="number"
                    v-model.number="item.input_discount_rate" class="form-control" @change="onChangeItem(item)" />
                  <ts-currency-converter-input v-else :input_amount.sync="item.input_discount_rate"
                    :amount.sync="item.discount_rate" :input_currency_id.sync="item.input_currency_id"
                    :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                    :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 120px;" />
                </td>
                <td>
                  <a-select v-model="item.incentive_type" class="ts-w-full" style="min-width: 50px"
                    @change="onChangeItem(item)">
                    <a-select-option value="%">%</a-select-option>
                    <a-select-option :value="getDiscountCurrency(item.input_currency_id)">
                      {{ getDiscountCurrency(item.input_currency_id) }}
                    </a-select-option>
                  </a-select>
                </td>
                <td>
                  <input v-if="item.incentive_type == '%'" ref="incentiveRate" type="number"
                    v-model.number="item.input_incentive_rate" class="form-control" @change="onChangeItem(item)" />
                  <ts-currency-converter-input v-else :input_amount.sync="item.input_incentive_rate"
                    :amount.sync="item.incentive_rate" :input_currency_id.sync="item.input_currency_id"
                    :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                    :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 120px;" />
                </td>
                <td class="text-center">
                  <a href="#" class="ts-text-red-700 hover:ts-text-red-700" @click.prevent="removeItem(index)">
                    <i class="fa fa-trash"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </fieldset>
    <!-- show product list pop-up -->
    <a-modal v-if="show_form" v-model="show_form" :title="$t('promotion.buyProduct')" :maskClosable="false"
      :footer="null" width="900px">
      <ProductList v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './modal-popup/incentive-by-amount-product-list.vue'
export default {
  name: 'invcentiveByAmountCondition',
  props: ['value', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
      errors: new Errors(),
      show_form: false,
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('promotion/incentiveByAmount', ['formViewDatas']),
  },
  methods: {
    addItem() {
      this.show_form = true
    },
    removeItem(index) {
      const product_id = this.model.condition[index].product_id
      this.formViewDatas['products'].find(el => el.product_id == product_id)._selected = false

      this.model.condition.splice(index, 1)
    },
    getDiscountCurrency(input_currency_id) {
      if (this.formViewDatas['currency']) {
        return this.formViewDatas['currency'].find(
          el => el.currency_id == input_currency_id
        ).currency_symbol
      }
      return null
    },
    getProduct(product_id) {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products'].find(el => el.product_id == product_id)
      }
    },
    operatorChange(row) {
      if (row.operator_sign != 'between') {
        row.amount_to = null
        row.input_amount_to = null
      }
    },
    onChangeItem(product) {
      if (product.discount_type == '%') {
        product.discount_rate = product.input_discount_rate
      } else {
        product.discount_type = this.getDiscountCurrency(product.input_currency_id)
        product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
      }

      if (product.incentive_type == '%') {
        product.incentive_rate = product.input_incentive_rate
      } else {
        product.incentive_type = this.getDiscountCurrency(product.input_currency_id)
        product.incentive_rate = product.input_incentive_rate * product.fx_rate_ratio
      }
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>